import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    directorsAppointments: [],
    directorsAppointment: {},
    totalItems: 0,
    assignments:[],
};

const getters = {
    index: state => id => state.directorsAppointments.findIndex(i => i.directorAppointmentId === id)
};

const mutations = {
    setDirectorsAppointments: (state, r) => (state.directorsAppointments = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    
    add: (state, r) => state.directorsAppointments.unshift(r),
    setDirectorsAppointment: (state, r) => (state.directorsAppointment = r),
    setAssignments: (state, r) => (state.assignments = r),
    cancel: (state, index) => state.directorsAppointments[index].status = status.rejected,
    approval: (state, index) => state.directorsAppointments[index].status = status.active,
    delete: (state, index) => state.directorsAppointments.splice(index, 1),

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.directorsAppointments.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setDirectorsAppointments", response.data.directorsAppointments);
            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.directorsAppointments.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.directorsAppointment);


        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
   
    async getDetails({ commit }, id) {
        try {
            commit("setDirectorsAppointment", {});
            console.log(id)
            startLoading()
            const response = await dataService.directorsAppointments.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setDirectorsAppointment", response.data.directorsAppointment);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
   
    async getCurrenttDirector(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.directorsAppointments.getCurrenttDirector(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getAssignments({ commit }) {
        try {
            startLoading();
            const response = await dataService.directorsAppointments.getAssignments();
            stopLoading();

            const assignments = response.data.assignments;
            commit("setAssignments", assignments);
        } catch (error) {
            stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.directorsAppointments.approval(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async cancel({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.directorsAppointments.cancel(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("cancel", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.directorsAppointments.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
